import * as API from '@common/api/template'
import * as T from './types'

export default {
    [T.GET_COMPONENT_TEMPLATE]({ commit }, payload) {
        commit(T.UPDATE_LOADING_STATUS, true)
        return API.getComponentTemplate(payload).then(data => {
            data = (data || []).map(item => {
                const { thumbnail } = item
                // 阿里云图片有缓存
                return {
                    ...item,
                    thumbnail: `${thumbnail}?v=${new Date(item.updatedAt).getTime()}`,
                    active: false,
                }
            })
            commit(T.SET_COMPONENT_TEMPLATE, data ?? [])
        }).finally(() => {
            commit(T.UPDATE_LOADING_STATUS, false)
        })
    },
    [T.ADD_COMPONENT_TEMPLATE](store, payload) {
        return API.addComponentTemplate(payload)
    },
    [T.EDIT_COMPONENT_TEMPLATE](store, payload) {
        return API.editComponentTemplate(payload)
    },
    [T.DELETE_COMPONENT_TEMPLATE](store, payload) {
        return API.deleteComponentTemplate(payload)
    },
}
